<app-view-quotation *ngIf="!loading && !error"></app-view-quotation>
<div *ngIf="error" class="container-fluid d-flex justify-content-center align-items-center vh-100 bg-light">
  <div class="text-center p-4 rounded shadow-sm bg-white" style="max-width: 420px;">
    <h5 class="mb-3 text-secondary">Action Required</h5>
    <p class="mb-4">
      Please log in to the portal and click the button below to retry viewing your order.
    </p>
    <button class="btn btn-primary px-4" (click)="reloadPage()">
      Retry
    </button>
  </div>
</div>
